import { createTheme } from "@mui/material";

/**
 * Tokens de marca Mential — fuente unica de verdad para colores/tipografia.
 * Paleta oficial (misma que la web corporativa). Regla del proyecto: los estilos
 * viven aqui (tema) o en componentes reutilizables, NUNCA hardcodeados inline.
 */
export const brand = {
    primary: "#3248CA",       // azul Mential — botones, enlaces, acentos
    primaryLight: "#5B6FD9",  // hover de primary
    navy: "#0E2B47",          // texto principal / fondo oscuro de bloques
    navyLight: "#485E75",     // texto secundario suave
    navyDark: "#0A243E",      // footer, secciones oscuras, CTAs
    accent: "#FF5F24",        // naranja destacado (Women's Health, alertas)
    accentMedium: "#FF8239",
    accentLight: "#FFA775",
    teal: "#ADCAD6",          // texto sobre fondos oscuros
    rose: "#F9E4E4",
    roseDark: "#E8B4B8",
    blueSlate: "#3D4F5F",     // hover/avatar del sidebar (web psicologo)
    borderLight: "#E2E8F0",  // borde de inputs (web psicologo — login, formularios)
    errorRed: "#DC2626",
    // Neutros (escala gris de la marca)
    gray50: "#F9FAFB",
    gray100: "#F3F4F6",
    gray200: "#E5E7EB",
    gray500: "#6B7280",
    gray600: "#4B5563",
    white: "#FFFFFF",
};

/**
 * Tokens tipograficos — misma fuente que la web del psicologo:
 * Inter (Google Fonts) para UI/cuerpo, Recoleta para titulos display de marca.
 * Cambiar aqui la fuente se propaga a toda la app.
 */
export const fonts = {
    body: "Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
    display: "Recoleta, Inter, Georgia, serif",
};

export const appTheme = createTheme({
    typography: {
        fontFamily: fonts.body,
        // Defaults MUI (base 16px) = mismo cuerpo que mential-webapp.
        // Sin negritas: titulos en Recoleta (peso normal), UI hasta 500 como maximo.
        h1: { fontFamily: fonts.display, fontWeight: 400 },
        h2: { fontFamily: fonts.display, fontWeight: 400 },
        h3: { fontFamily: fonts.display, fontWeight: 400 },
        h4: { fontFamily: fonts.display, fontWeight: 400 },
        h5: { fontFamily: fonts.display, fontWeight: 400 },
        h6: { fontFamily: fonts.body, fontWeight: 500 },
        subtitle1: { fontWeight: 500 },
        subtitle2: { fontWeight: 500 },
        body1: { fontSize: "1rem", lineHeight: 1.75 },
        button: { fontFamily: fonts.body, fontWeight: 500 },
    },
    palette: {
        primary: { main: brand.primary, light: brand.primaryLight },
        secondary: { main: brand.gray200 },
        navy: { main: brand.navy, light: brand.navyLight, dark: brand.navyDark },
        accent: { main: brand.accent, medium: brand.accentMedium, light: brand.accentLight },
        teal: { main: brand.teal },
        background: { default: "#F8FAFC", paper: brand.white },
        text: { primary: brand.navy, secondary: brand.gray600 },
        divider: brand.gray100,
    },
    shape: { borderRadius: 16 },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    border: `1px solid ${brand.gray100}`,
                },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: { root: { textTransform: "none" } },
        },
    },
});

export default appTheme;
